import _classCallCheck from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

/**
 * @class AddedLmIntent
 */
// tslint:disable-next-line:max-classes-per-file
export var AddedLmIntent =
/**
 * Creates and initializes an instance of this class.
 * @constructor
 * @param modelImpl - The model.
 * @param intentName - The intent name.
 */
function AddedLmIntent(modelImpl, intentName) {
  _classCallCheck(this, AddedLmIntent);

  this.modelImpl = modelImpl;
  this.intentName = intentName;
};